<template>
  <div class="subitem">
    <div v-for="(subitem, index) in subitems" v-if="isLogin(subitem.isLogin)" :key="index">
      <h5 v-if="subitem.link == 'disable' || subitem.link == 'default'" class="subitem__item">{{subitem.title}}</h5>
      <router-link v-else class="subitem__item" tag="div" :to="{name: subitem.link}">{{subitem.title}}</router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-sub-item',
  components: {

  },
  props: {
    subitems: {
      required: false
    },
    parent: {
      required: false
    }
  },
  data() {
    return {
      selected: null
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    isLogin(isRequired) {
      const token = this.$store.getters.token
      const isSuperuser = this.$store.getters.isSuperuser
      const staff = this.$store.getters.isStaff
      const groups = this.$store.getters.groups.split(',')
      if(isRequired && token) {
        if (isSuperuser) {
          return true
        }
        if (isRequired === 'staff' && !staff) {
          return false
        }
        if (isRequired === 'superuser' && !isSuperuser) {
          return false
        }
        if (isRequired === 'usermanager' && !groups.includes('user_manager')) {
          return false
        }
        if (isRequired === 'opsspv' && !groups.includes('OpsSupervisor')) {
          return false
        }
        if (isRequired === 'GA' && !groups.includes('GA')) {
          return false
        }
        if (isRequired === 'opsspvorga' && !groups.includes('OpsSupervisor') && !groups.includes('GA')) {
          return false
        }
        return true
      } else if (isRequired && token == '') {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>